import { render } from "./ViewApprovisionnementPage.vue?vue&type=template&id=2e848003&ts=true"
import script from "./ViewApprovisionnementPage.vue?vue&type=script&lang=ts"
export * from "./ViewApprovisionnementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__